import React, { useState, useEffect, useRef, Fragment } from "react";
import {
  Card,
  Grid,
  Paper,
  Button,
  CardActions,
  Theme,
  FormHelperText,
  CardContent,
  Radio,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";

import { makeStyles, createStyles } from "@material-ui/core/styles";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { postApiCall, getApiCall } from "../../services/_common";
import {
  AddOwnerPaymentSettings,
  GetOwnerPaymentSettings,
  SUB_DIRCTORY,
} from "../../../app_config";
import { commonMsg, showToast } from "./../../../constants";
import { Breadcrumb, MatxLoading } from "../../../matx";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      position: "relative",
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
  })
);

const PaymentSetting = () => {
  const classes = useStyles();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const user = useSelector((state: any) => state.user);

  // States
  const [isLoading, setIsLoading] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentTypeError, setPaymentTypeError] = useState(false);

  // Stripe States
  const [PublishKey, setPublishKey] = useState("");
  const [SecretKey, setSecretKey] = useState("");

  // Square States
  const [SeApplicationId, setSeApplicationId] = useState("");
  const [SeAccessToken, setSeAccessToken] = useState("");
  const [seLocationId, setseLocationId] = useState("");

  // PayPal States
  const [paypalPublickey, setPaypalPublickey] = useState("");
  const [paypalPrivateKey, setPaypalPrivateKey] = useState("");
  const [paypalTokenizationkey, setPaypalTokenizationkey] = useState("");
  const [paypalMerchentID, setPaypalMerchentID] = useState("");

  // Finix States
  const [finixApiKey, setFinixApiKey] = useState("");
  const [finixApplicationId, setFinixApplicationId] = useState("");
  const [finixMerchantId, setFinixMerchantId] = useState("");
  const [finixMerchantIdentityId, setFinixMerchantIdentityId] = useState("");

  const [PaymentSettingsId, setPaymentSettingsId] = useState("");
  const [Production, setProduction] = useState("Sandbox"); // Default to Sandbox to avoid unselected UI state

  const formRef = useRef<any>(null);

  const getPaymentMethodsByaonwerId = () => {
    setIsLoading(true);
    const parms = `ParkingBuisnessOwnerId=${user.ParkingBusinessOwnerId}`;
    getApiCall(GetOwnerPaymentSettings, parms)
      .then((response) => {
        if (response.Status) {
          if (response.Data) {
            setIsLoading(true);
            setProduction(response.Data.IsProduction === true ? "Production" : "Sandbox");
            setPaymentType(response.Data.PaymentMethod || "");
            setPaymentSettingsId(response.Data.PaymentSettingsId || "");

            if (response.Data.PaymentMethod === "Stripe") {
              setPublishKey(response.Data.ApiKey || "");
              setSecretKey(response.Data.SecretKey || "");
              setSeApplicationId("");
              setSeAccessToken("");
              setseLocationId("");
              setPaypalPublickey("");
              setPaypalTokenizationkey("");
              setPaypalPrivateKey("");
              setPaypalMerchentID("");
              setFinixApiKey("");
              setFinixApplicationId("");
              setFinixMerchantId("");
              setFinixMerchantIdentityId("");
            } else if (response.Data.PaymentMethod === "Paypal") {
              setPaypalPublickey(response.Data.ApiKey ? response.Data.ApiKey.trim() : "");
              setPaypalPrivateKey(response.Data.SecretKey ? response.Data.SecretKey.trim() : "");
              setPaypalTokenizationkey(response.Data.ApplicationId ? response.Data.ApplicationId.trim() : "");
              setPaypalMerchentID(response.Data.LocationId ? response.Data.LocationId.trim() : "");
              setPublishKey("");
              setSecretKey("");
              setSeApplicationId("");
              setSeAccessToken("");
              setseLocationId("");
              setFinixApiKey("");
              setFinixApplicationId("");
              setFinixMerchantId("");
              setFinixMerchantIdentityId("");
            } else if (response.Data.PaymentMethod === "Finix") {
              setFinixApiKey(response.Data.ApiKey || response.Data.apiKey || "");
              setFinixApplicationId(response.Data.ApplicationId || response.Data.applicationId || "");
              setFinixMerchantId(response.Data.MerchantId || response.Data.merchantId || "");
              setFinixMerchantIdentityId(response.Data.MerchantIdentityId || response.Data.merchantIdentityId || "");
              setPublishKey("");
              setSecretKey("");
              setSeApplicationId("");
              setSeAccessToken("");
              setseLocationId("");
              setPaypalPublickey("");
              setPaypalTokenizationkey("");
              setPaypalPrivateKey("");
              setPaypalMerchentID("");
            } else {
              setSeApplicationId(response.Data.ApplicationId || "");
              setSeAccessToken(response.Data.AccessToken || "");
              setseLocationId(response.Data.LocationId || "");
              setPublishKey("");
              setSecretKey("");
              setPaypalPublickey("");
              setPaypalTokenizationkey("");
              setPaypalPrivateKey("");
              setPaypalMerchentID("");
              setFinixApiKey("");
              setFinixApplicationId("");
              setFinixMerchantId("");
              setFinixMerchantIdentityId("");
            }
          }
        } else {
          setIsLoading(false);
          showToast(
            enqueueSnackbar,
            response.Message,
            "Error",
            "error",
            closeSnackbar
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        showToast(
          enqueueSnackbar,
          error,
          "Error",
          "error",
          closeSnackbar
        );
      });
  };

  useEffect(() => {
    getPaymentMethodsByaonwerId();
  }, []);

  const handleChangeCheckbox = (event: any) => {
    setProduction(event.target.value);
  };

  const handleChange = (event: any) => {
    event.persist();
    const { name, value } = event.target;

    if (name === "paymentType") {
      setPaymentType(value);
      if (value !== "") {
        setPaymentTypeError(false);
      }
    } else if (name === "PublishKey") {
      setPublishKey(value);
    } else if (name === "SecretKey") {
      setSecretKey(value);
    } else if (name === "SeApplicationId") {
      setSeApplicationId(value);
    } else if (name === "SeAccessToken") {
      setSeAccessToken(value);
    } else if (name === "seLocationId") {
      setseLocationId(value);
    } else if (name === "paypalTokenizationkey") {
      setPaypalTokenizationkey(value);
    } else if (name === "paypalMerchentID") {
      setPaypalMerchentID(value);
    } else if (name === "paypalPublickey") {
      setPaypalPublickey(value);
    } else if (name === "paypalPrivateKey") {
      setPaypalPrivateKey(value);
    } else if (name === "finixApiKey") {
      setFinixApiKey(value);
    } else if (name === "finixApplicationId") {
      setFinixApplicationId(value);
    } else if (name === "finixMerchantId") {
      setFinixMerchantId(value);
    } else if (name === "finixMerchantIdentityId") {
      setFinixMerchantIdentityId(value);
    }
  };

  const handleSubmit = () => {
    if (paymentType === "") {
      setPaymentTypeError(true);
      return;
    }

    const postData: any = {
      ParkingBusinessOwnerId: user.ParkingBusinessOwnerId,
      PaymentMethod: paymentType,
      ApiKey:
        paymentType === "Stripe"
          ? (PublishKey || "").trim()
          : paymentType === "Paypal"
            ? (paypalPublickey || "").trim()
            : paymentType === "Finix"
              ? (finixApiKey || "").trim()
              : null,
      SecretKey:
        paymentType === "Stripe"
          ? (SecretKey || "").trim()
          : paymentType === "Paypal"
            ? (paypalPrivateKey || "").trim()
            : null,
      ApplicationId:
        paymentType === "Square"
          ? (SeApplicationId || "").trim()
          : paymentType === "Paypal"
            ? (paypalTokenizationkey || "").trim()
            : paymentType === "Finix"
              ? (finixApplicationId || "").trim()
              : null,
      LocationId:
        paymentType === "Square"
          ? (seLocationId || "").trim()
          : paymentType === "Paypal"
            ? (paypalMerchentID || "").trim()
            : null,
      AccessToken:
        paymentType === "Square"
          ? (SeAccessToken || "").trim()
          : null,
      IsProduction: Production === "Production" ? true : false,
      MerchantId:
        paymentType === "Finix"
          ? (finixMerchantId || "").trim()
          : null,
      MerchantIdentityId:
        paymentType === "Finix"
          ? (finixMerchantIdentityId || "").trim()
          : null,

      parkingBusinessOwnerId: user.ParkingBusinessOwnerId,
      paymentMethod: paymentType,
      apiKey:
        paymentType === "Stripe"
          ? (PublishKey || "").trim()
          : paymentType === "Paypal"
            ? (paypalPublickey || "").trim()
            : paymentType === "Finix"
              ? (finixApiKey || "").trim()
              : null,
      secretKey:
        paymentType === "Stripe"
          ? (SecretKey || "").trim()
          : paymentType === "Paypal"
            ? (paypalPrivateKey || "").trim()
            : null,
      applicationId:
        paymentType === "Square"
          ? (SeApplicationId || "").trim()
          : paymentType === "Paypal"
            ? (paypalTokenizationkey || "").trim()
            : paymentType === "Finix"
              ? (finixApplicationId || "").trim()
              : null,
      locationId:
        paymentType === "Square"
          ? (seLocationId || "").trim()
          : paymentType === "Paypal"
            ? (paypalMerchentID || "").trim()
            : null,
      accessToken:
        paymentType === "Square"
          ? (SeAccessToken || "").trim()
          : null,
      isProduction: Production === "Production" ? true : false,
      merchantId:
        paymentType === "Finix"
          ? (finixMerchantId || "").trim()
          : null,
      merchantIdentityId:
        paymentType === "Finix"
          ? (finixMerchantIdentityId || "").trim()
          : null,
    };
    if (PaymentSettingsId) {
      postData.PaymentSettingsId = PaymentSettingsId;
      postData.paymentSettingsId = PaymentSettingsId;
    }

    setIsLoading(true);
    postApiCall(AddOwnerPaymentSettings, postData)
      .then((res) => {
        if (res.Status) {
          setIsLoading(false);
          showToast(
            enqueueSnackbar,
            res.Message,
            "Success",
            "success",
            closeSnackbar
          );
          getPaymentMethodsByaonwerId();
        } else {
          setIsLoading(false);
          showToast(
            enqueueSnackbar,
            res.Message,
            "Error",
            "error",
            closeSnackbar
          );
        }
      })
      .catch((error) => {
        setIsLoading(false);
        showToast(
          enqueueSnackbar,
          error,
          "Error",
          "error",
          closeSnackbar
        );
      });
  };

  return (
    <Fragment>
      <div className="m-sm-30">
        <div className="mb-sm-30">
          <Breadcrumb
            routeSegments={[
              {
                name: "Payment Settings",
                path: `${SUB_DIRCTORY}/session/payment-setting`,
              },
            ]}
          />
        </div>
        <div className="custom-wrapper">
          <ValidatorForm ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid className="marginauto" item xs={12} sm={12} md={7} lg={7}>
                <Paper className="paper">
                  <Card>
                    <CardContent>
                      <div>
                        <FormControl
                          component="fieldset"
                          className="marginTenpx"
                          error={paymentTypeError}
                        >
                          <FormLabel component="legend">
                            Payment Type
                          </FormLabel>
                          <RadioGroup
                            value={paymentType}
                            name="paymentType"
                            onChange={handleChange}
                            row
                          >
                            <FormControlLabel
                              value="Stripe"
                              control={<Radio color="primary" />}
                              label="Stripe Payment"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Square"
                              control={<Radio color="primary" />}
                              label="Square Payment"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Paypal"
                              control={<Radio color="primary" />}
                              label="Paypal"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Finix"
                              control={<Radio color="primary" />}
                              label="Finix Payment"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                          <FormHelperText>
                            {paymentTypeError ? commonMsg.PaymentTypeError : ""}
                          </FormHelperText>
                        </FormControl>
                      </div>

                      {/* Stripe Form */}
                      {paymentType && paymentType === "Stripe" && (
                        <div>
                          <TextValidator
                            className="mb-4 w-full"
                            id="PublishKey"
                            label="Stripe Publishable Key"
                            name="PublishKey"
                            value={PublishKey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.PublishError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="SecretKey"
                            label="Stripe Secret Key"
                            name="SecretKey"
                            value={SecretKey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.SecretKeyError}
                            onChange={handleChange}
                            type="text"
                          />

                          <RadioGroup
                            value={Production}
                            name="Production"
                            onChange={handleChangeCheckbox}
                            row
                          >
                            <FormControlLabel
                              value="Production"
                              control={<Radio color="primary" />}
                              label="Production"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Sandbox"
                              control={<Radio color="primary" />}
                              label="Sandbox"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </div>
                      )}

                      {/* Square Form */}
                      {paymentType && paymentType === "Square" && (
                        <div>
                          <TextValidator
                            className="mb-4 w-full"
                            id="SeApplicationId"
                            label="Square Application Id"
                            name="SeApplicationId"
                            value={SeApplicationId}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.SeApplicationIdError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="SeAccessToken"
                            label="Square Access Token "
                            name="SeAccessToken"
                            value={SeAccessToken}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.SeAccessTokenError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="seLocationId"
                            label="Square Location Id "
                            name="seLocationId"
                            value={seLocationId}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.seLocationId}
                            onChange={handleChange}
                            type="text"
                          />

                          <RadioGroup
                            value={Production}
                            name="Production"
                            onChange={handleChangeCheckbox}
                            row
                          >
                            <FormControlLabel
                              value="Production"
                              control={<Radio color="primary" />}
                              label="Production"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Sandbox"
                              control={<Radio color="primary" />}
                              label="Sandbox"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </div>
                      )}

                      {/* PayPal Form */}
                      {paymentType && paymentType === "Paypal" && (
                        <div>
                          <TextValidator
                            className="mb-4 w-full"
                            id="paypalTokenizationkey"
                            label="Tokenization key"
                            name="paypalTokenizationkey"
                            value={paypalTokenizationkey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.PAYPALTOKEN}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="paypalMerchentID"
                            label="Merchant ID"
                            name="paypalMerchentID"
                            value={paypalMerchentID}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.PAYPALMerchant}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="paypalPublickey"
                            label="Public Key"
                            name="paypalPublickey"
                            value={paypalPublickey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.PAYPALPublish}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="paypalPrivateKey"
                            label="Private key"
                            name="paypalPrivateKey"
                            value={paypalPrivateKey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.PAYPALPrivate}
                            onChange={handleChange}
                            type="text"
                          />
                          <RadioGroup
                            value={Production}
                            name="Production"
                            onChange={handleChangeCheckbox}
                            row
                          >
                            <FormControlLabel
                              value="Production"
                              control={<Radio color="primary" />}
                              label="Production"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Sandbox"
                              control={<Radio color="primary" />}
                              label="Sandbox"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </div>
                      )}

                      {/* Finix Form */}
                      {paymentType && paymentType === "Finix" && (
                        <div>
                          <TextValidator
                            className="mb-4 w-full"
                            id="finixApiKey"
                            label="API Key"
                            name="finixApiKey"
                            value={finixApiKey}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.FinixApiKeyError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="finixApplicationId"
                            label="Application Id"
                            name="finixApplicationId"
                            value={finixApplicationId}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.FinixApplicationIdError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="finixMerchantId"
                            label="Merchant Id"
                            name="finixMerchantId"
                            value={finixMerchantId}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.FinixMerchantIdError}
                            onChange={handleChange}
                            type="text"
                          />
                          <TextValidator
                            className="mb-4 w-full"
                            id="finixMerchantIdentityId"
                            label="Merchant Identity Id"
                            name="finixMerchantIdentityId"
                            value={finixMerchantIdentityId}
                            validators={commonMsg.BASIC_VALIDATORS}
                            errorMessages={commonMsg.FinixMerchantIdentityIdError}
                            onChange={handleChange}
                            type="text"
                          />
                          <RadioGroup
                            value={Production}
                            name="Production"
                            onChange={handleChangeCheckbox}
                            row
                          >
                            <FormControlLabel
                              value="Production"
                              control={<Radio color="primary" />}
                              label="Production"
                              labelPlacement="end"
                            />
                            <FormControlLabel
                              value="Sandbox"
                              control={<Radio color="primary" />}
                              label="Sandbox"
                              labelPlacement="end"
                            />
                          </RadioGroup>
                        </div>
                      )}
                    </CardContent>

                    <CardActions className="button-right">
                      <Button
                        className="ml-2"
                        color="primary"
                        variant="contained"
                        type="submit"
                      >
                        <span className="pl-2 capitalize">
                          {PaymentSettingsId === "" ? "SAVE" : "UPDATE"}
                        </span>
                      </Button>
                    </CardActions>
                    <br />
                  </Card>
                </Paper>
              </Grid>
            </Grid>
          </ValidatorForm>
        </div>
      </div>
      {isLoading && <MatxLoading />}
    </Fragment>
  );
};

export default PaymentSetting;
